import pt from '../locales/pt';
import { toLocalISODate } from './selfiePeriod';

/** Re-export canónico — implementação em `selfiePeriod.toLocalISODate`. */
export { toLocalISODate };

export function todayISO() {
  return toLocalISODate(new Date());
}

export function formatQuickDateLabel(isoDate) {
  if (!isoDate) return '';
  const today = todayISO();
  if (isoDate === today) return pt.quickCreate.dateToday;

  const date = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(date.getTime())) return isoDate;

  return date.toLocaleDateString('pt-PT', {
    day: 'numeric',
    month: 'short',
  });
}

export function formatQuickMonthYear(isoDate) {
  if (!isoDate) return '';
  const date = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString('pt-PT', { month: 'short', year: 'numeric' });
}

export function formatQuickCalendarMonth(year, monthIndex) {
  const date = new Date(year, monthIndex, 1, 12);
  return date.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' });
}

/** Monday-first weekday index: Mon=0 … Sun=6 */
export function mondayFirstWeekday(date) {
  return (date.getDay() + 6) % 7;
}

/**
 * Build a 6×7 calendar grid for a month.
 * @returns {{ iso: string, day: number, inMonth: boolean }[]}
 */
export function buildMonthGrid(year, monthIndex) {
  const first = new Date(year, monthIndex, 1, 12);
  const startOffset = mondayFirstWeekday(first);
  const gridStart = new Date(year, monthIndex, 1 - startOffset, 12);
  const cells = [];

  for (let i = 0; i < 42; i += 1) {
    const cell = new Date(gridStart);
    cell.setDate(gridStart.getDate() + i);
    cells.push({
      iso: toLocalISODate(cell),
      day: cell.getDate(),
      inMonth: cell.getMonth() === monthIndex,
    });
  }

  return cells;
}

export function clampISODate(isoDate, min, max) {
  if (!isoDate) return isoDate;
  if (min && isoDate < min) return min;
  if (max && isoDate > max) return max;
  return isoDate;
}

export function isISODateDisabled(isoDate, min, max) {
  if (min && isoDate < min) return true;
  if (max && isoDate > max) return true;
  return false;
}

export function shiftMonth(year, monthIndex, delta) {
  const date = new Date(year, monthIndex + delta, 1, 12);
  return { year: date.getFullYear(), monthIndex: date.getMonth() };
}
